import React, { useState, useEffect, forwardRef, Fragment } from "react";
import { Divider, Row, Col, Icon } from 'antd';
import Title from 'antd/es/typography/Title';
import Paragraph from 'antd/es/typography/Paragraph';
import TranslatedText from "translations/TranslatedText";
import PreloadedImage from 'ReusableComponents/PreloadedImage';
import { fetchResponsesLocal, fetchQuizLocal } from 'quizdb';
import { getQuestionName, getQuizName, getAnswer,
         fetchResponses, } from 'lib';
import Score from './Score';

export default forwardRef((props: any, ref: any) => {
  const { inputData, language, checkAnswer, } = props,
    { questions, toolConfig, } = inputData,
    { showScore } = toolConfig;

  const quizName = getQuizName();
  const quiz = fetchQuizLocal(quizName);
  let numQuestions = 0;
  let score = 0;
  Object.entries(quiz).forEach((entry) => {
    const questionName = entry[0];
    const response = fetchResponses(questionName);
    const question = entry[1];
    const answer = getAnswer(question);
    if (response !== undefined) {
      if (response == answer) {
        score++
      }
      numQuestions++
    }
  });

  return (
    <Row type="flex" justify="center"
         align="middle"
         style={{ marginTop: "8vh" }}
     >
      <Col>
        <Row type="flex" justify="center" align="middle">
          <Col>
            <PreloadedImage image="logo" />
          </Col>
        </Row>
        <Row type="flex" justify="center" align="middle">
          <Col pull={1}>
            <Icon style={{ fontSize: '1em' }} type="star" theme="twoTone" twoToneColor="#f56626" />
            <Icon style={{ fontSize: '1.25em' }} type="star" theme="twoTone" twoToneColor="#f56626" />
            <Icon style={{ fontSize: '1.5em' }} type="star" theme="twoTone" twoToneColor="#f56626" />
          </Col>
          <Col>
            <Title level={2}><TranslatedText id="student.message.finished.heading" /></Title>
          </Col>
          <Col push={1}>
            <Icon style={{ fontSize: '1.5em' }} type="star" theme="twoTone" twoToneColor="#f56626" />
            <Icon style={{ fontSize: '1.25em' }} type="star" theme="twoTone" twoToneColor="#f56626" />
            <Icon style={{ fontSize: '1em' }} type="star" theme="twoTone" twoToneColor="#f56626" />
          </Col>
        </Row>
        <Row type="flex" justify="center" align="middle">
          <Col>
            <Title level={4}><TranslatedText id="student.message.finished.introduction" />{getQuizName()}</Title>
          </Col>
        </Row>
        {
          showScore && (
            <Row type="flex" justify="center" align="middle">
              <Col>
                <Score score={score} numQuestions={numQuestions} />
              </Col>
            </Row>
          )
        }
        <Row type="flex" justify="center" align="middle">
          <Col>
            <Title level={1}>
              <TranslatedText id="student.message.finished.conclusion" />
              <Icon type="smile" theme="twoTone" twoToneColor="#f56626" />
            </Title>
          </Col>
        </Row>
      </Col>
    </Row>
  );
})
